export const AuthConstants = {
    LOGIN: 'AUTH_LOGIN',
    LOGOUT: 'AUTH_LOGOUT',
    FAILED: 'AUTH_FAILED',
    AUTH: 'CHECK_USER_AUTH',
    UPDATE: 'UPDATE_PROFILE',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    REFRESH_TOKEN_FAILED: 'REFRESH_TOKEN_FAILED',
    CLEAR: 'AUTH_CLEAR'
}

export const NotificationConstants = {
    GET: 'GET_NOTIFICATIONS',
    ADD: 'ADD_NOTFICATION',
    UPDATE: 'UPDATE_NOTFICATION',
    DELETE: 'DELETE_NOTFICATION',
    FAIL: 'FAIL_NOTFICATIONS',    
    CLEAR: 'CLEAR_NOTFICATIONS',    
}

export const RoleConstants = {
    GET: 'GET_ROLES',
    ADD: 'ADD_ROLES',
    UPDATE: 'UPDATE_ROLE',
    DELETE: 'DELETE_ROLE',
    FAIL: 'FAIL_ROLES',
    CLEAR: 'CLEAR_ROLES',
    LOADING: 'ROLES_LOADING',
    RESOURCES: 'GET_RESOURCES'
}

export const UserConstants = {
    GET: 'GET_USERS',
    ADD: 'ADD_USER',
    UPDATE: 'UPDATE_USER',
    DELETE: 'DELETE_USER',
    REMOVE_DOC: 'REMOVE_USER_DOC',
    FAIL: 'FAIL_USERS',
    CLEAR: 'CLEAR_USERS',
    LOADING: 'USERS_LOADING'    
}

export const CampusConstants = {
    GET: 'GET_CAMPUSES',
    ADD: 'ADD_CAMPUS',
    UPDATE: 'UPDATE_CAMPUS',
    DELETE: 'DELETE_CAMPUS',
    LOADING: 'CAMPUSES_LOADING',
    REMOVE_DOC: 'REMOVE_ CAMPUS_DOC',
    FAIL: 'FAIL_CAMPUSES',
    CLEAR: 'CLEAR_CAMPUSES',
}

export const SectionConstants = {
    GET: 'GET_SECTIONS',
    ADD: 'ADD_SECTION',    
    UPDATE: 'UPDATE_SECTION',
    DELETE: 'DELETE_SECTION',
    LOADING: 'SECTIONS_LOADING',    
    FAIL: 'FAIL_SECTIONS',
    CLEAR: 'CLEAR_SECTIONS',
}

export const GradeConstants = {
    GET: 'GET_GRADES',
    ADD: 'ADD_GRADE',
    UPDATE: 'UPDATE_GRADE',
    DELETE: 'DELETE_GRADE',
    LOADING: 'GRADES_LOADING',    
    FAIL: 'FAIL_GRADES',
    CLEAR: 'CLEAR_GRADES',
}

export const SessionConstants = {
    GET: 'GET_SESSIONS',
    ADD: 'ADD_SESSION',
    ACTIVE: 'GET_ACTIVE_SESSION',
    UPDATE: 'UPDATE_SESSION',
    DELETE: 'DELETE_SESSION',
    LOADING: 'SESSIONS_LOADING',    
    FAIL: 'FAIL_SESSIONS',
    CLEAR: 'CLEAR_SESSIONS',
}

export const StudentConstants = {
    GET: 'GET_STUDENTS',
    ADD: 'ADD_STUDENT',
    UPDATE: 'UPDATE_STUDENT',
    DELETE: 'DELETE_STUDENT',
    REMOVE_DOC: 'REMOVE_STUDENT_DOC',
    FAIL: 'FAIL_STUDENTS',
    CLEAR: 'CLEAR_STUDENTS',
    LOADING: 'STUDENTS_LOADING'    
}

export const FeeConstants = {
    GET: 'GET_FEES',
    ADD: 'ADD_FEES',
    UPDATE: 'UPDATE_FEE',
    DELETE: 'DELETE_FEE',
    LOADING: 'FEE_LOADING',    
    FAIL: 'FAIL_FEES',
    MONTHS: 'FEE_MONTHS',
    CLEAR: 'CLEAR_FEES',
}

export const AttendanceConstants = {
    GET: 'GET_ATTENDANCE',
    ADD: 'ADD_ATTENDANCE',
    UPDATE: 'UPDATE_ATTENDANCE',
    DELETE: 'DELETE_ATTENDANCE',
    LOADING: 'ATTENDANCE_LOADING',    
    FAIL: 'FAIL_ATTENDANCE',    
    CLEAR: 'CLEAR_ATTENDANCE',
}


export const PayrollConstants = {
    GET: 'GET_PAYROLL',
    LIST: 'GET_PAYROLL_LIST',
    ADD: 'ADD_PAYROLL',
    UPDATE: 'UPDATE_PAYROLL',
    DELETE: 'DELETE_PAYROLL',
    LOADING: 'PAYROLL_LOADING',    
    FAIL: 'FAIL_PAYROLL',
    MONTHS: 'PAYROLL_MONTHS',
    CLEAR: 'CLEAR_PAYROLL',
}